// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { CustomProductState } from "@conklin/App/Store/Reducers/xProductDetails";
import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";

type HandlerType = Handler<{ customProductStates: CustomProductState[] }>;

export const DispatchSetCustomProductState: HandlerType = (props: {
    readonly parameter: Readonly<{
        customProductStates: CustomProductState[];
    }>;
    dispatch: any;
}) => {
    props.dispatch({
        type: "xProductDetails/SetCustomProductState",
        customProductStates: props.parameter.customProductStates,
    });
};

export const chain = [DispatchSetCustomProductState];

const setCustomProductState = createHandlerChainRunner(chain, "SetCustomProductState");
export default setCustomProductState;
